module.exports = __webpack_public_path__ + "img/new-guide-04-2.1d9a6831.png";